// extracted by mini-css-extract-plugin
export default {"h1":"Typography_h1__lotZ-","h6":"Typography_h6__Pq5sz","st1":"Typography_st1__unZHP","p":"Typography_p__JnXzO"};